<template>
  <div class="background">
    <div class="main">
      <div class="header">
        <i class="iconfont iconx" @click="close"></i>
        <div class="header-content">
          <img :src='personInfo.avatar_url' alt="">
          <div>
            <p>{{personInfo.username}}</p>
            <p v-if="personInfo.is_membership">超级会员：{{moment(personInfo.membership_expired_at).format('YYYY-MM-DD')}}
              到期</p>
            <p v-else>开通会员享受更多特权</p>
          </div>
        </div>
      </div>
                                                                   
      <div class="content_detail">
       <div class="detail">
         <div class="detail_info">
           <p class="info_title">订单信息</p>
           <div class="info_main">
             <p>订 单 号：   {{info.order.trade_no}}</p>
             <p>订单类型：{{info.order.display_plan}}</p>
             <p>订单价格：¥ {{info.order.final_price / 100}}</p>
           </div>
           <p></p>
         </div>
       </div>
      </div>    

      <div class="content">
        <div class="pay">
          <div class="Qrcode">
            <qrcode-vue :value="`${host}/pay/type?type=${(info.order.model_name === 'MentorOrders' )? 'mentor' :'member'}&orderId=${info.order.token}&coupon_id=${couponsToken}`"
                        :size="126"
                        class="Qrcode-component"/>
             <div class="qrcode-not" v-show="!Math.max(...[(info.order.price/100).toFixed(2),0])">
              <p>无需扫码</p>
              <p>点击「立即购买」</p>
            </div>
          </div>
          <div class="pay-content">

             <p><span class="pic-num">￥{{ info.order.final_price / 100}}</span><span
                class="preferential-pic"
                v-show="(info.order.final_price / 100)> info.order.price">（优惠券：-¥ {{(info.order.final_price / 100) - info.order.price}}）</span>
            </p>
            <p>
              <img src="https://files.wondercv.com/web/member/wechat.png">
              <img src="https://files.wondercv.com/web/member/alipay.png">
            </p>
            <p>请使用支付宝/微信扫一扫，轻松支付！</p>
          </div>
          <div class="pay-success-btn" v-show="isShowBtn">
            <div class="btn" @click="handleClickCheck" v-if="(info.order.final_price / 100) - info.order.price">
              我已支付
            </div>
            <div class="btn" @click="handleClickPay" v-else>
              立即购买
            </div>
            <div class="text" >遇到问题？请咨询右下角客服</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import {mapState, mapActions} from "vuex"
  import moment from "moment"
  import qrcodeVue from 'qrcode-vue';
  import api from "../../../api";
  import {get_tUser, routerTo} from "@/assets/js/util"

  export default {
    name: "payAlert",
    props: {
      activePic: {
        type: Number,
        default: 19
      },
      orderId: {
        type: String
      },
      info: {
           type: Object,
           default: () => {
           }
      }
    },
    data() {
      return {
        detail: {},
        moment,
        //会员选项李贝奥
        //优惠券列表
        couponsList: [],
        //优惠券左移右移下标
        couponsIndex: 0,
        //价格
        pic: this.info.order.price / 100,
        //优惠券价格
        couponsPic: 0,
        //优惠券id
        couponsToken: "",
        //优惠券兑换码
        couponsText: "",
        //点击支付时状态（做假节流）
        isPayLoading: false,
        host: "",//域名
        isShowBtn: false,
        isError: false,
        timer: null,//轮训定时器
        isShowError: false
      }
    },
    computed: {
      ...mapState("me", ["personInfo"])
    },
    components: {
      qrcodeVue
    },
    async created() {
      console.log(this.info.order.token)
      console.log(this.info)
      let host = window.location.origin
      this.host = host.replace("www", "m")
      if (process.env.NODE_ENV === 'development') {
        this.host = 'https://m.wondercv.cn'
      }
      this._getOrderDetail(this.info.order.token,this.info.order.model_name)
      setTimeout(() => {
        this.isShowBtn = true
      }, 3000)
    },
    async mounted() {
      document.body.style.overflow = 'hidden'
      this.checkOrder()
       this.timer = setInterval(() => {
        this.checkOrder()
      }, 3000) 
    },
    methods: {
      ...mapActions('me', ['getUserInfo']),
      async close() {
        await this.getUserInfo()
        document.body.style.overflow = 'visible'
        this.$emit("close")
      },
      // 获取订单详情
       async _getOrderDetail (token,type){
         let { c_t } = get_tUser()
        console.log(type,this.info)
        const _type = type === 'MentorOrders' ? 'mentor_order' : 'improved_order'
        let res = await api.account.getOrderDetail(c_t, token, {type: _type})
         console.log(res)
        if (res.code === 1000) {
           this.detail = res.data
        }

       },
      //0元购买
      async handleClickPay() {
        if (this.isPayLoading) return
        this.isPayLoading = true
        let res = await api.account.orderPay(this.info.order.token, {pay_type: 'wx_pay'})
        //console.log(this.isPayLoading,res)
        if (res.code === 1000) {
          this.$message.success("支付成功")
          
          await this.getUserInfo()
          setTimeout(() => {
            if (this.info.order.model_name === 'MentorOrders') {
             routerTo(`/service/pay_success/${this.info.order.token}`)
            }else {
              let type = {
                '99': 'super',
                '119': 'superplus'
              }
              routerTo(`/pay/success?type=${type[(this.info.order.price / 100)] || 'vip'}`)
            }
          }, 500)
          this.close()
        }
        this.isPayLoading = false
      },
      //检查订单
      async handleClickCheck() {
        if (this.isError) {
          return
        }
        this.isError = true

        let res =''
         if (this.info.order.model_name === "MentorOrders"){
              res = await api.account.checkOrder(this.info.order.token,{order_type:'mentor'})
         } else {
             res = await api.account.checkOrder(this.info.order.token)
         }
        console.log(this.isError,res)
        if (res.code == 1000) {
          let {status} = res.data
          if (status == 'paid') {
            this.$message.success("支付成功")
            this.isError = false
            await this.getUserInfo()
          } else {
            this.$message.error("订单支付失败，请继续支付")
            this.isError = false
            this.isShowError = true
          }
        } else {
          this.$message.error(res.message)
        }
      },
      //检查订单结果()
      async checkOrder() {
         let res =''
         if (this.info.order.model_name === "MentorOrders"){
              res = await api.account.checkOrder(this.info.order.token,{order_type:'mentor'})
         } else {
             res = await api.account.checkOrder(this.info.order.token)
         }
         console.log(res)
        if (res.code == 1000) {
          let {status} = res.data
         // console.log(status)
          if (status == 'paid') {
            this.$message.success("支付成功")
            await this.getUserInfo()
            clearInterval(this.timer)
            setTimeout(() => {
              if (this.info.order.model_name === 'MentorOrders') {
                routerTo(`/service/pay_success/${this.info.order.token}`)
              }else {
                let type = {
                  '99': 'super',
                  '119': 'superplus'
                }
                let price = this.info.order.price / 100
                routerTo(`/pay/success?type=${type[price] || 'vip'}`)
              }
            }, 500)

          }
        }
      }
    },
    beforeDestroy() {
      clearInterval(this.timer)
    }
  }
</script>

<style scoped lang="scss">
  .background {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background-color: rgba(0, 0, 0, 0.5);
    z-index: 999;
  }

  .main {
    width: 700px;
    box-sizing: border-box;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    border-radius: 8px;
    transition: all .5s;

    .header {
      height: 90px;
      background: rgba(65, 70, 83, 1);
      border-radius: 8px 8px 0px 0px;
      padding: 24px 32px;
      box-sizing: border-box;

      .iconx {
        position: absolute;
        font-size: 24px;
        color: rgba(255, 255, 255, 1);
        opacity: 0.7;
        top: 20px;
        right: 32px;
        cursor: pointer;
      }

      .header-content {
        display: flex;
        align-items: center;
      }

      .header-content > img {
        width: 42px;
        height: 42px;
        border-radius: 50%;
        margin-right: 16px;
      }

      .header-content > div {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        color: #fff;
      }

      .header-content > div > p:nth-of-type(1) {
        font-size: 16px;
        font-weight: 400;
        margin-bottom: 10px;
      }

      .header-content > div > p:nth-of-type(2) {
        font-size: 12px;
        font-weight: 300;
      }
    }

    .content {
      padding: 24px 32px;
      background-color: #fff;
      border-radius: 0 0 8px 8px;

      .vip-options {
        display: flex;
        margin-bottom: 24px;

        .vip-item {
          width: 149px;
          height: 88px;
          background: rgba(245, 246, 250, 1);
          border-radius: 8px;
          margin-right: 12px;
          color: #404040;
          box-sizing: border-box;
          font-weight: 400;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          cursor: pointer;

          .pic {
            font-size: 14px;
            margin-bottom: 12px;

            & > span {
              font-size: 24px;
            }
          }

          .text {
            font-size: 12px;
            font-weight: 400;
            line-height: 12px;
            color: #9C9C9C
          }

          &.active {
            background: linear-gradient(180deg, rgba(255, 159, 121, 1) 0%, rgba(255, 102, 68, 1) 100%);
            box-shadow: 0px 4px 16px 0px rgba(255, 102, 68, 0.3);
            color: #fff;

            .text {
              color: #fff
            }
          }
        }
      }

      .coupons-main {
        width: 636px;
        border-radius: 8px 8px 0px 0px;
        box-sizing: border-box;
        margin-bottom: 24px;

        &.has-list {
          border: 1px solid rgba(245, 246, 250, 1);
          border-radius: 8px;
        }
      }

      .coupons-header {
        height: 52px;
        background: rgba(245, 246, 250, 1);
        border-radius: 8px 8px 0px 0px;
        padding-left: 24px;
        padding-right: 16px;
        line-height: 52px;
        color: #404040;
        display: flex;
        align-items: center;

        .coupons-input {
          border: none;
          outline: none;
          height: 20px;
          flex: 1;
          background-color: transparent;
          margin-right: 10px;
        }

        .coupons-submit {
          width: 98px;
          height: 32px;
          background: rgba(65, 70, 83, 1);
          box-shadow: 0px 3px 5px 0px rgba(0, 0, 0, 0.05);
          border-radius: 4px;
          color: #fff;
          line-height: 32px;
          text-align: center;
          cursor: pointer;

        }
      }

      .coupons-list {
        width: 100%;
        height: 101px;
        background: #fff;
        display: flex;
        flex-wrap: nowrap;
        overflow: hidden;
        position: relative;
        border-radius: 0px 0px 8px 8px;

        .page {
          position: absolute;
          width: 24px;
          height: 32px;
          background: rgba(65, 70, 83, .5);
          top: 32px;
          cursor: pointer;
          z-index: 20;
          display: flex;
          justify-content: center;
          align-items: center;

          &:hover {
            background: rgba(65, 70, 83, .8);
          }

          &.left {
            left: 16px;
            border-radius: 0px 100px 100px 0px;
          }

          &.right {
            right: 16px;
            border-radius: 100px 0px 0px 100px;
          }

          & > i {
            font-size: 24px;
            color: #fff;
          }
        }

        .list-container {
          display: flex;
          width: 100%;
          padding: 0 16px;
          align-items: center;
          transition: all 0.4s;
          position: relative;
          z-index: 10;

          .list-item {
            width: 196px;
            height: 64px;
            background-image: url("https://files.wondercv.com/web/member/defult.png");
            background-repeat: no-repeat;
            background-size: 100%;
            margin-right: 8px;
            padding: 16px 12px;
            align-items: center;
            box-sizing: border-box;
            display: flex;
            cursor: pointer;

            .item-pic {
              width: 42px;
              height: 22px;
              font-size: 12px;
              font-weight: 400;
              color: rgba(255, 102, 68, 1);
              line-height: 22px;
              margin-right: 16px;
              color: #404040;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;

              span {
                font-size: 16px;
              }
            }

            .item-text-time {
              flex: 1;
              text-align: center;
              font-size: 12px;
              font-weight: 300;
              display: flex;
              align-items: center;
              flex-direction: column;

              & > p {
                width: 111px;
                margin: 0 auto;
                white-space: nowrap;
                line-height: 100%;
              }

              & > p:first-child {
                color: #404040;
                margin-bottom: 8px;
                font-weight: 500;
                overflow: hidden;
                text-overflow: ellipsis;
              }

              & > p:last-child {
                color: #9C9C9C;
                font-weight: 300;
              }
            }

            &:last-child {
              margin-right: 0px;
            }

            &:hover {
              background-image: url("https://files.wondercv.com/web/member/hover.png");

              .item-pic {
                color: #FF6644
              }

              .item-text-time {
                & > p {
                  color: #FF6644;
                }
              }
            }

            &.active {
              background-image: url("https://files.wondercv.com/web/member/active.png");

              .item-pic {
                color: #FF6644
              }

              .item-text-time {
                & > p {
                  color: #FF6644;
                }
              }
            }

          }
        }

     }

      .pay {
        width: 637px;
        height: 174px;
        border-radius: 8px;
        margin-bottom: 4px;
        box-sizing: border-box;
        border: 1px solid rgba(245, 246, 250, 1);
        padding: 24px;
        display: flex;

        .Qrcode {
          width: 126px;
          height: 126px;
          background: #00ff80;
          margin-right: 18px;
          position: relative;

          .Qrcode-component {
            width: 126px;
            height: 126px;

            img {
              width: 126px;
              height: 126px;
            }

            /deep/ img {
              width: 126px;
              height: 126px;
            }
          }

          .qrcode-not {
            position: absolute;
            top: 0;
            left: 0;
            width: 126px;
            height: 126px;
            background-color: rgba(255, 255, 255, 0.93);
            text-align: center;
            font-size: 14px;
            font-weight: 400;
            color: rgba(64, 64, 64, 1);
            line-height: 24px;
            display: flex;
            flex-direction: column;
            justify-content: center;
          }
        }

        .pay-content {
          display: flex;
          flex-direction: column;
          justify-content: center;

          & > p {
            display: flex;
            margin-bottom: 16px;
            color: #404040;
            font-size: 14px;
            align-items: flex-end;

            &:last-child {
              margin-bottom: 0;
            }

            .pic-num {
              font-size: 28px;
              font-weight: 600;
              color: rgba(255, 102, 68, 1);
            }

            .preferential-pic {
              font-size: 16px;
              font-weight: 400;
              color: #FF6644;
            }

            & > img {
              width: 24px;
              height: 24px;
              margin-right: 16px;
            }
          }
        }

        .pay-success-btn {
          flex: 1;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: flex-end;

          .btn {
            margin-top: 11px;
            width: 104px;
            height: 36px;
            background: linear-gradient(180deg, rgba(255, 159, 121, 1) 0%, rgba(255, 102, 68, 1) 100%);
            border-radius: 2px;
            margin-bottom: 20px;
            text-align: center;
            line-height: 36px;
            font-weight: 400;
            color: rgba(255, 255, 255, 1);
            font-size: 14px;
            cursor: pointer;
            margin-right: 25px;
          }

          .text {
            height: 14px;
            font-size: 14px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: rgba(255, 102, 68, 1);
            line-height: 14px;
          }
        }
      }


    }
    .content_detail {
        padding: 0 32px;
        padding-top: 24px;
        background-color: #fff;
        .detail {
          display: flex;
          align-items: center;
          width: 637px;
          height: 152px;
          border-radius: 8px;
          background-color:  #F5F6FA;;
          //margin-bottom: 4px;
          box-sizing: border-box;
          border: 1px solid rgba(245, 246, 250, 1);
          .detail_info {
            margin-left: 24px;
            width: 500px;
            height: 104px;
            .info_title {
              height: 16px;
              line-height: 16px;
              font-size:16px;
              font-weight:500;
              color:rgba(64,64,64,1);
            }
            .info_main {
              margin-top: 15px;
              p {
                height: 16px;
                line-height: 16px;
                margin-bottom: 12px;
                font-size:14px;
                font-weight:400;
                color:rgba(96,96,96,1);
              }
            }
          }
       }
      }
  }


</style>